import React from 'react'
import Sidebar from '../../components/Sidebar'
import ManageProjectComponent from '../../components/ManageProjectComponent/ManageProjectComponent'
import Navbar from '../../components/Navbar'
import ManageClusterComponent from '../../components/ManageClusterComponent/ManageClusterComponent'

const ManageCluster = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManageClusterComponent/>
                </div>
            </div>
        </div>
    )
}

export default ManageCluster
